@if (item && item.data) {
<div class="flex">

    <!-- image -->
    <div class="w-3 p-r-2">
        <div [ngClass]="item.isGiftcard ? 'ratio-3-2' : 'ratio-2-3'"
             [class.giftcardItemImage]="item.isGiftcard">
            <img class="rf"
                 [options]="item.isGiftcard ? {} : {fitIn: true}"
                 [image]="image">
        </div>
    </div>

    <div class="w-9">
        <div class="flex flex-justify-between">
            <div class="m-t-1">
                @if(item.isFreeGift) {
                <p class="s2 col-56 w-12">{{'Free Gift' | translate}}</p>
                }
                <!-- name -->
                <p class="p2 col-11">{{product?.data?.name}}</p>
            </div>


            <!-- price -->
            <p class="p2 col-11 p-l-2 right">
                @if (item.isReward) {
                <!-- reward points display -->
            <div class="flex flex-middle">
                <i class="inline-flex icon-coins"
                   style="font-size: 24px"></i>
                <span class="p2 col-1">{{ item.rewardPoints }}</span>
            </div>
            } @else {
            <price class="block-s price p1"
                   [ngClass]="{'col-2' : rowOrgPrice}"
                   [useFreeLabel]="item.isFreeGift"
                   [value]="item.isFreeGift ? item.data.rowPrice : rowPrice"></price>
            @if (rowOrgPrice) {
            <price class="line-through col-13 price p1"
                   [value]="rowOrgPrice"></price>
            }
            }
            </p>
        </div>

        <!-- configurable options -->
        @if (item.configurableOptions?.length) {
        <div>
            @for (option of item.configurableOptions; track $index; let isFirst = $first) {
            <span class="c1 col-12">
                {{(isFirst ? '' : ' | ') + (option.value | optionLabel : option.code)}}
            </span>
            }
        </div>
        }

        @if(!item.isFree || item.isReward) {
        <!-- qty -->
        <div class="flex-column">
            @if (!item.isGiftcard && !item.isVirtual) {
            <item-qty class="item-qty"
                      [model]="data.qty"
                      [product]="product!"
                      [max]="maxQty"
                      [min]="product?.minQty"
                      [status]="status"
                      [itemId]="item.id"
                      (qtyChange)="setQty($event, true)"></item-qty>
            }

            <div class="flex m-t-1">
                <!-- remove -->
                <action class="flex flex-middle cursor-pointer"
                        (click)="removeFromBasket()"
                        [status]="removeStatus"
                        [attr.aria-label]="'Remove' | translate">
                    <i class="icon-close inline-flex"
                       aria-hidden="true"
                       [style.font-size.rem]="0.75"></i>
                </action>

                <!-- add to wishlist -->
                <lp-wishlist-toggle [productId]="product?.id!"></lp-wishlist-toggle>
            </div>
        </div>
        }
    </div>
</div>

}